const cards = [
  {
    title: '在线吃瓜线路一：最稳定的主入口',
    desc: '线路一是在线吃瓜官方首选通道，经过长期优化拥有最快的响应速度和最稳定的连接质量，推荐所有用户优先使用。',
    tag: '推荐首选',
    accent: 'primary' as const,
  },
  {
    title: '91在线吃瓜网官方域名解析指南',
    desc: '了解91在线吃瓜网的域名解析机制，掌握当DNS被污染时如何通过备用网址和官方线路正常访问。',
    tag: '技术解析',
    accent: 'accent' as const,
  },
  {
    title: '在线吃瓜备用网址使用须知',
    desc: '备用网址是主入口异常时的最佳替代方案。本文详细说明各备用线路的特点、适用场景及切换方法。',
    tag: '备用指引',
    accent: 'secondary' as const,
  },
  {
    title: '吃瓜通道专题：多维度内容导航',
    desc: '围绕吃瓜通道打造的专题内容聚合，涵盖娱乐、影视、社会等多个维度的热门话题与深度报道。',
    tag: '专题聚合',
    accent: 'primary' as const,
  },
  {
    title: '在线吃瓜最新入口变更公告',
    desc: '及时获取在线吃瓜最新入口的变更通知，包括域名更换、线路调整、节点更新等重要信息。',
    tag: '重要公告',
    accent: 'accent' as const,
  },
  {
    title: '在线吃瓜官方线路安全认证报告',
    desc: '定期发布的官方线路安全检测报告，包含各入口的安全评分、访问速度、稳定性等详细数据。',
    tag: '安全报告',
    accent: 'secondary' as const,
  },
  {
    title: '从入门到精通：在线吃瓜使用全攻略',
    desc: '新手必读的完整使用指南，从首次访问到高级技巧，帮助您全面掌握在线吃瓜的所有功能。',
    tag: '新手指南',
    accent: 'primary' as const,
  },
];

const tagStyles: Record<string, string> = {
  primary: 'bg-primary-500/15 text-primary-400',
  accent: 'bg-accent-500/15 text-accent-400',
  secondary: 'bg-secondary-500/15 text-secondary-400',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-secondary-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-file-list-3-line text-secondary-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">吃瓜精选</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((card, i) => (
            <div key={i} className={`p-5 rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/15 transition-all duration-200 cursor-pointer ${
              i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
            }`}>
              <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium mb-3 ${tagStyles[card.accent]}`}>
                {card.tag}
              </span>
              <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-2">{card.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              <div className="flex items-center gap-1 mt-4 text-xs text-foreground-500 hover:text-primary-400 transition-colors">
                <span>了解更多</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}